import { format, isSameDay, isSameMonth, isSameYear } from 'date-fns';
import { DateRange } from 'react-day-picker';

import { EDateFormat } from 'detailsv2/structure';

import * as constants from './constants';

export const getFormattedDatesRange = (datesRange: DateRange) => {
  if (!datesRange.from) return null;
  if (!datesRange.to || isSameDay(datesRange.from, datesRange.to)) return format(datesRange.from, 'MMMM d, yyyy');

  if (isSameMonth(datesRange.from, datesRange.to)) {
    return `${format(datesRange.from, 'MMMM d')} - ${format(datesRange.to, 'd, yyyy')}`;
  }

  if (isSameYear(datesRange.from, datesRange.to)) {
    return `${format(datesRange.from, 'MMMM d')} - ${format(datesRange.to, 'MMMM d, yyyy')}`;
  }

  return `${format(datesRange.from, 'MMMM d, yyyy')} - ${format(datesRange.to, 'MMMM d, yyyy')}`;
};

export const getNumericalFormattedDatesRange = (datesRange: DateRange, dateFormat?: EDateFormat) => {
  if (!datesRange.from) return null;
  if (!datesRange.to || isSameDay(datesRange.from, datesRange.to))
    return getNumericalFormattedDate(datesRange.from, dateFormat);

  if (isSameMonth(datesRange.from, datesRange.to)) {
    return `${getNumericalFormattedDate(datesRange.from, dateFormat, true)} - ${getNumericalFormattedDate(datesRange.to, dateFormat)}`;
  }

  if (isSameYear(datesRange.from, datesRange.to)) {
    return `${getNumericalFormattedDate(datesRange.from, dateFormat, true)} - ${getNumericalFormattedDate(datesRange.to, dateFormat)}`;
  }

  return `${getNumericalFormattedDate(datesRange.from, dateFormat)} - ${getNumericalFormattedDate(datesRange.to, dateFormat)}`;
};

export const getNumericalFormattedDate = (date: Date | undefined, dateFormat?: EDateFormat, withoutYear?: boolean) => {
  if (!date) return null;

  if (withoutYear) {
    if (dateFormat === EDateFormat.YMD) return format(date, constants.NUMERICAL_NO_YEAR_YMD_FORMAT);
    if (dateFormat === EDateFormat.DMY) return format(date, constants.NUMERICAL_NO_YEAR_DMY_FORMAT);
    return format(date, constants.NUMERICAL_NO_YEAR_MDY_FORMAT);
  }

  if (dateFormat === EDateFormat.YMD) return format(date, constants.NUMERICAL_YMD_FORMAT);
  if (dateFormat === EDateFormat.DMY) return format(date, constants.NUMERICAL_DMY_FORMAT);

  return format(date, constants.NUMERICAL_MDY_FORMAT);
};
